import { getCurrentStorageName, getObjectFromSession, setObjectToSession } from '@/utils/session-utils';

import {
  SET_SEARCH_TEXT,
  SET_ONLY_ATIVOS,
  SET_LIST_OPTIONS,
  SET_CURRENT_PAGE,
  SET_FILTER,
  SET_OFFSET,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
} from './mutations.type';

import { PREFIX_SESSION_STATE_NAME } from './constants';

export default {
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_ONLY_ATIVOS](state, onlyAtivos) {
    state.onlyAtivos = onlyAtivos;
  },
  [SET_CURRENT_PAGE](state, page) {
    state.listOptions.page = page;
  },
  [SET_FILTER](state, filter) {
    state.listOptions.filter = filter;
  },
  [SET_OFFSET](state, offset) {
    state.listOptions.offset = offset;
  },
  [SET_LIST_OPTIONS](state, listOptions) {
    state.listOptions = listOptions;
  },
  [SET_CURRENT_SESSION_STATE](state, ids) {
    const stateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );

    if (stateName) {
      setObjectToSession(stateName, state);
    }
  },
  [INIT_STATE](state, ids) {
    const currentStateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );
    const sessionObjectState = getObjectFromSession(currentStateName);

    state.searchText = sessionObjectState?.searchText || state.searchText;
    state.onlyAtivos = sessionObjectState?.onlyAtivos || state.onlyAtivos;
    state.listOptions = sessionObjectState?.listOptions || state.listOptions;
  },
};
